import cx from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Button from '../buttons/button';
import * as style from './tabbutton.module.scss';

const TabButton = forwardRef(({ active, className, ...props }, ref) => {
  return (
    <Button
      {...props}
      className={cx(className, active && style.active, style.tabButton)}
      ref={ref}
      size="small"
      theme="light"
    />
  );
});

TabButton.displayName = 'TabButton';

TabButton.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default TabButton;
